<div
  class="orgApp-d-flex orgApp-flex-dir-col orgApp-gap-16 orgApp-change-pwd-main-div"
>
  <div class="orgApp-d-flex">
    <h2 mat-dialog-title class="orgApp-dialog-heading orgApp-change-pwd-title orgApp-d-flex orgApp-align-i-center">
      <b> {{ "manage_profile.action.change_password" | translate }}</b>
    </h2>
    <button
      class="orgApp-margin-left-auto"
      type="button"
      mat-icon-button
      (click)="cancelForm()"
    >
    <svg width="24" height="24">
      <use xlink:href="#close-icon"></use>
    </svg>
    </button>
  </div>
  <div class="orgApp-change-pwd-h-full orgApp-gap-8 orgApp-d-flex orgApp-flex-dir-col">
    <mat-dialog-content class="orgApp-change-pwd-dialog-content orgApp-change-pwd-div">
      <form [formGroup]="changePassword" class="orgApp-change-pwd-margin" autocomplete="off">
        <div
          class="orgApp-d-flex orgApp-flex-dir-col orgApp-gap-4"
        >
          @if(!samePwd){
            <div class="orgApp-d-flex orgApp-cp-error-div orgApp-gap-8">
              <div class="orgApp-cp-error-icon-div">
                <svg width="20" height="20" class="orgApp-margin-top-4">
                  <use xlink:href="#error-warn-icon"></use>
                </svg>
              </div>
             <span>
              {{ "manage_profile.change_password.error.same_password" | translate }}
            </span>
            </div>
          }
          <mat-form-field
            floatLabel="always"
            appearance="outline"
            class="orgApp-field-rounded-sm orgApp-input-field-md"
          >
            <mat-label>
              {{
                "manage_profile.change_password.label.current_password"
                  | translate
              }}</mat-label
            >
            <input
              matInput
               name="currentPasswordField" autocomplete="new-password"
              formControlName="oldPassword"
              placeholder="{{
                'manage_profile.change_password.placeholder.current_password'
                  | translate
              }}"
            />
          </mat-form-field>
          <mat-form-field
            floatLabel="always"
            appearance="outline"
            class="orgApp-field-rounded-sm orgApp-input-field-pwd"
            [ngClass]="{
              error:
                changePassword.get('newPassword')?.hasError('whitespace') ||
                changePassword.get('newPassword')?.hasError('invalidPassword')
            }"
          >
            <mat-label>
              {{
                "manage_profile.change_password.label.new_password" | translate
              }}</mat-label
            >
            <input
              matInput (input)="passwordMatchValidator()"
              [type]="hideNewPwd ? 'password' : 'text'"
              name="newPasswordField" autocomplete="new-password"
              formControlName="newPassword"
              placeholder="{{
                'manage_profile.change_password.placeholder.new_password'
                  | translate
              }}"
            />

            <button
              mat-icon-button
              matSuffix
              class="orgApp-login-password-eye"
              (click)="togglePasswordVisibility('hideNewPwd')"
            >
              <svg width="24" height="24">
                <use [attr.xlink:href]="hideNewPwd ? '#visibility-login-off' : '#visibility-login-on'"></use>
              </svg>
            </button>
            <mat-hint>
              <b class="orgApp-input-field-pwd-hint">{{
                "manage_profile.change_password.hint.hint" | translate
              }}</b
              >{{ "manage_profile.change_password.hint.hint_msg" | translate }}
            </mat-hint>
            <mat-error
              *ngIf="
                changePassword.get('newPassword')?.hasError('invalidPassword')
              "
            >
            {{ "manage_profile.change_password.error.password_format" | translate }}
            </mat-error>
          </mat-form-field>
          <mat-form-field
            floatLabel="always"
            appearance="outline"
            class="orgApp-field-rounded-sm orgApp-input-field-md orgApp-input-field"
            [ngClass]="{
              error: changePassword
                .get('confirmPassword')
                ?.hasError('whitespace')
            }"
          >
            <mat-label>
              {{
                "manage_profile.change_password.label.confirm_password"
                  | translate
              }}</mat-label
            >
            <input
              matInput
              id="confirmPassword"
              [type]="hideConfirmPwd ? 'password' : 'text'"
              formControlName="confirmPassword" (input)="passwordMatchValidator()"
              placeholder="{{
                'manage_profile.change_password.placeholder.confirm_password'
                  | translate
              }}"
            />
            <button
              mat-icon-button
              matSuffix
              class="orgApp-login-password-eye"
              (click)="togglePasswordVisibility('hideConfirmPwd')"
            >
              <svg width="24" height="24">
                <use [attr.xlink:href]="hideConfirmPwd ? '#visibility-login-off' : '#visibility-login-on'"></use>
              </svg>
            </button>
          </mat-form-field>
          @if (changePassword.get('confirmPassword')?.touched){
            <ng-container>
              @if(!passwordMatch){
              <mat-error class="orgApp-font-12 orgApp-line-ht-13 orgApp-change-pwd-title">
                {{ "manage_profile.change_password.error.password_mismatch" | translate }}
              </mat-error>
              }
            </ng-container>
          }
        </div>
      </form>
    </mat-dialog-content>
    <mat-dialog-actions class="orgApp-d-flex  orgApp-change-pwd-action">
      <button
        mat-stroked-button
        class="orgApp-stroked-btn-primary orgApp-change-pwd-btn orgApp-modal-button"
        (click)="cancelForm()"
      >
        {{ "manage_profile.change_password.action.cancel_btn" | translate }}
      </button>
      <button
        mat-raised-button
        [ngClass]="{
          disable: !changePassword.valid || !passwordMatch
        }"
        class="orgApp-raised-btn-primary orgApp-change-pwd-btn orgApp-modal-button"
        [disabled]="!changePassword.valid || !passwordMatch"
        (click)="updatePwd()"
      >
        {{ "manage_profile.change_password.action.save_btn" | translate }}
      </button>
    </mat-dialog-actions>
  </div>
</div>
